





















































































































































import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import * as R from 'ramda'
import moment from 'moment-timezone'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/exercise/keys'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import {
  ActionNames as PatientWithExerciseSummarysActionNames,
  GetterNames as PatientWithExerciseSummaryGetterNames,
} from '@/store/modules/patient-with-exercise-summarys/keys'
import {
  ActionNames as ExerciseProgramActionNames,
  GetterNames as ExerciseProgramGetterNames,
} from '@/store/modules/exercise-program/keys'
import { generatePdfFromHtml } from '@/utils/pdf-export'
import { getCsvDownloadFunction } from '@/http/utils'
import { getPatientName, getPatientInitials, sortByPatientName } from '@/utils/patients'
import { LoadingTypes } from '@/store/modules/exercise/types'
import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'

import ExerciseSessionReportHead from '@/components/exercises/components/ExerciseSessionReportHead.vue'
import ExerciseSessionReportVitalsData from '@/components/exercises/components/ExerciseSessionReportVitalsData.vue'
import ExerciseSessionReportExerciseTable from '@/components/exercises/components/ExerciseSessionReportExerciseTable.vue'
import SearchForm from '@/components/sub-components/SearchForm.vue'
import StatusLabel from '@/components/sub-components/StatusLabel.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'
import { FlatPatientExercise } from '@/store/modules/exercise/getters'

import { VitalStatsDisplayOptions } from '@/constants/exercise-program'

type ComponentData = {
  showInitialLoading: boolean
  isDeletingPatientExercise: boolean
  isPatchingPatientExercise: boolean
  searchText: string
  filterPatientsByExerciseProgramId: string
  chosenPatientId: string
  vitalStatsDisplayToggle: VitalStatsDisplayOptions.Table | VitalStatsDisplayOptions.Graph
  isGeneratingExport: boolean
  isGeneratingExportDialogText: string
}

export default Vue.extend({
  components: {
    //PatientExerciseSummaryCard,
    //ExerciseButton,
    ExerciseSessionReportHead,
    ExerciseSessionReportVitalsData,
    ExerciseSessionReportExerciseTable,
    SearchForm,
    StatusLabel,
    IsGeneratingExportDialog,
  },
  data(): ComponentData {
    return {
      showInitialLoading: true,
      isDeletingPatientExercise: false,
      isPatchingPatientExercise: false,
      vitalStatsDisplayToggle: VitalStatsDisplayOptions.Table,
      searchText: '',
      filterPatientsByExerciseProgramId: null,
      chosenPatientId: '',
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },
  computed: {
    showFullScreenLoading(): boolean {
      return this.showInitialLoading || this.isDeletingPatientExercise
    },
    navigationFromExerciseProgramId() {
      return this.$route.query.from_exercise_program || false
    },
    filteredPatients() {
      let patientArray = this.detailedPatientsWithExerciseSummarys
      if (this.filterPatientsByExerciseProgramId) {
        patientArray = this.detailedPatientsWithExerciseSummarys.filter(patient => {
          return this.chosenExerciseProgram.participants.find(participant => participant === patient.id)
        })
      }
      const lowerCasedSearchText = this.searchText.toLowerCase()
      return patientArray.filter(patient => {
        const patientText = `${patient.phoneNumber} ${getPatientName(patient)}`.toLowerCase()
        return patientText.includes(lowerCasedSearchText)
      })
    },
    filteredPatientsByPatientName() {
      return sortByPatientName(this.filteredPatients)
    },
    detailedPatientsWithExerciseSummarys() {
      return this.allPatients.filter(patient => {
        return this.patientsWithExerciseSummarys.find(patientWithSummary => patientWithSummary.id === patient.id)
      })
    },
    chosenPatientFormattedLastExerciseDate() {
      if (this.noExercisesForChosenPatient) {
        return null
      }
      return moment(this.chosenPatientExercises[0].exerciseDate).format('Do MMMM YYYY')
    },
    chosenPatientStatusLabel() {
      const statusMap = {
        active: { color: '#1fc151', text: 'Active' },
        complete: { color: '#0f45cd', text: 'Complete' },
      }
      return statusMap[this.chosenPatient.status]
    },
    chosenPatientExercises() {
      return this.sortedExercises.filter(exercise => exercise.patientId === this.chosenPatientId)
    },
    chosenPatient() {
      return this.allPatients.find(patient => patient.id === this.chosenPatientId)
    },
    noExercisesForChosenPatient() {
      return R.isEmpty(this.chosenPatientExercises)
    },
    vitalStatsDisplayOptions() {
      return [
        {
          text: VitalStatsDisplayOptions.Table,
          isActive: this.vitalStatsDisplayToggle === VitalStatsDisplayOptions.Table,
        },
        {
          text: VitalStatsDisplayOptions.Graph,
          isActive: this.vitalStatsDisplayToggle === VitalStatsDisplayOptions.Graph,
        },
      ]
    },
    exportAllPatientExercisesForChosenPatientOptions() {
      return [
        {
          label: 'Export to PDF',
          icon: 'mdi-file-pdf-box',
          action: this.exportAllPatientExercisesForChosenPatientToPdf,
        },
        {
          label: 'Export to CSV',
          icon: 'mdi-google-spreadsheet',
          action: this.exportAllPatientExercisesForChosenPatientToCsv,
        },
      ]
    },
    exerciseProgramPropsForFilter() {
      const programs = this.exercisePrograms.map(program => ({
        title: program.title,
        id: program.id,
      }))
      return [{ title: 'All programs', id: '' }, ...programs]
    },
    showSummaryCards(): boolean {
      return (
        this.filteredPatientWithExerciseSummarys &&
        this.filteredPatientWithExerciseSummarys.length > 0 &&
        this.sortedExercises.length
      )
    },
    ...mapState(ModuleNames.exercise, ['loading']),
    ...mapGetters(ModuleNames.exercise, {
      sortedExercises: GetterNames.sortedExercises,
    }),
    ...mapGetters(ModuleNames.patient, {
      allPatients: PatientGetterNames.patients,
    }),
    ...mapGetters(ModuleNames.patientWithExerciseSummarys, {
      patientsWithExerciseSummarys: PatientWithExerciseSummaryGetterNames.patientWithExerciseSummarys,
      patientsWithExerciseSummarysByFullName:
        PatientWithExerciseSummaryGetterNames.patientWithExerciseSummarysOrderedByFullName,
    }),
    ...mapGetters(ModuleNames.exerciseProgram, {
      chosenExerciseProgram: ExerciseProgramGetterNames.chosenExerciseProgram,
      exercisePrograms: ExerciseProgramGetterNames.exercisePrograms,
    }),
  },
  async mounted(): Promise<void> {
    await Promise.all([
      this[PatientActionNames.getPatients](),
      this[PatientWithExerciseSummarysActionNames.getPatientWithExerciseSummarys](),
      this[ActionNames.getExercises](),
      this.getExercisePrograms(),
    ])
    if (this.navigationFromExerciseProgramId) {
      this.setChosenExerciseProgramId(this.navigationFromExerciseProgramId)
      this.filterPatientsByExerciseProgramId = this.navigationFromExerciseProgramId
    }
    this.setInitialChosenPatientId()
    this.showInitialLoading = false
  },
  methods: {
    toggleVitalStatsDisplay(opt: VitalStatsDisplayOptions.Table | VitalStatsDisplayOptions.Graph) {
      this.vitalStatsDisplayToggle = opt
    },
    async exportSinglePatientExerciseToPdf(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Pdf
      this.isGeneratingExport = true
      const exercise = this.chosenPatientExercises.find(exercise => exercise.id === e)
      await generatePdfFromHtml({
        filename: `Agartee Patient Exercise Report (${this.getFullName(this.chosenPatient)} - ${
          exercise.exerciseDate
        })`,
        source: this.$refs[`pdfPatientExercise_${e}`][0],
        pagebreak: {
          avoid: 'tr',
        },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportAllPatientExercisesForChosenPatientToPdf() {
      this.isGeneratingExportDialogText = ExportDialogs.Pdf
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: `Agartee Patient Exercise Report (${this.getFullName(this.chosenPatient)} - All Sessions)`,
        source: this.$refs.pdfAllPatientExercises,
        pagebreak: {
          avoid: 'tr',
          after: '.pdf-page-break-after',
        },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportSinglePatientExerciseToCsv(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Csv
      this.isGeneratingExport = true
      const singlePatientExerciseCsv = getCsvDownloadFunction({
        path: `patient-exercises/${this.chosenPatientId}/${e}`,
      })
      await singlePatientExerciseCsv()
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportAllPatientExercisesForChosenPatientToCsv(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Csv
      this.isGeneratingExport = true
      const allPatientExerciseCsv = getCsvDownloadFunction({
        path: `patient-exercises/${this.chosenPatientId}`,
      })
      await allPatientExerciseCsv()
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async postExercise(patientId): Promise<void> {
      const newExerciseId = await this[ActionNames.postExercise]({ patientId })
      this.$router.push({ name: 'exercises-detail', params: { exercise_id: newExerciseId }, query: { edit: '' } })
    },
    async deletePatientExercise(e): Promise<void> {
      this.isDeletingPatientExercise = true
      await this[ActionNames.deleteExercise]({ exerciseId: e })
      this.isDeletingPatientExercise = false
    },
    getFullName(participant) {
      return getPatientName(participant)
    },
    getInitials(participant) {
      return getPatientInitials(participant)
    },
    setChosenPatientId(patientId) {
      this.chosenPatientId = patientId
    },
    setInitialChosenPatientId() {
      if (!R.isEmpty(this.filteredPatientsByPatientName)) {
        this.setChosenPatientId(this.filteredPatientsByPatientName[0].id)
      }
    },
    handleProgramChange() {
      this.setChosenExerciseProgramId(this.filterPatientsByExerciseProgramId)
      this.setInitialChosenPatientId()
    },
    ...mapActions(ModuleNames.exercise, [
      ActionNames.getExercises,
      ActionNames.postExercise,
      ActionNames.deleteExercise,
    ]),
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.patientWithExerciseSummarys, [
      PatientWithExerciseSummarysActionNames.getPatientWithExerciseSummarys,
    ]),
    ...mapActions(ModuleNames.exerciseProgram, {
      getExercisePrograms: ExerciseProgramActionNames.getExercisePrograms,
      setChosenExerciseProgramId: ExerciseProgramActionNames.setChosenExerciseProgramId,
    }),
  },
})
